var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homewrap"},[(_vm.$store.main.state.userToken)?_c('HomeLogged'):_c('div',[(_vm.$route.query.source == 'homescreen')?_c('Login'):(_vm.isGpt)?_c('HomeGpt'):_c('HomePublic')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }